export default "__VITE_ASSET__79967ba8__"